import React, { useState, useEffect } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/ProfileManagement/ViewProfile.css'
import save from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-left.svg';
import saveEnable from '../../../Assets/ProfileManagement/Assets-Desktop/userprofile.svg';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import editenable from '../../../Assets/ProfileManagement/Assets-Desktop/editenable.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/ProfileManagement/Modal.css';
import Message from '../../../Data/Shared/Message.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { PROFILE_ENDPOINT } from '../../../Services/config/apiEndPoints';
// for redux
import { useSelector } from 'react-redux';
import { AES, enc } from 'crypto-js';

const ViewProfile = () => {
    const userProfileDataR = useSelector(state => JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
    const [isEdit, setIsEdit] = useState(false);
    const [userData, setUserData] = useState([]);
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState('');
    let [firstnameerror, setFirstnameError] = useState();
    let [lastnameerror, setLastnameError] = useState();
    const [isSave, setIsSave] = useState(false);
    const [getUserDetails, setUserDetails] = useState(true);
    const EditValue = () => {
        setIsEdit(true);
        if (isSave) {
            setFirstname(firstname);
            setLastname(lastname);
            setEmail(email);
        } else {
            setFirstname(userData.userdetails?.user.firstName);
            setLastname(userData.userdetails?.user.lastName);
            setEmail(userData.userdetails?.user.userEmail);
        }
        setIsSave(false);
    }
    const handleChangeFirstName = (e) => {
        setFirstname(e.target.value);
        setFirstnameError();
        document.getElementById('firstname').style.border = "1px solid #B2B2B2";
    }
    const handleChangeLastName = (e) => {
        setLastname(e.target.value);
        setLastnameError();
        document.getElementById('lastname').style.border = "1px solid #B2B2B2";
    }
    const SaveValue = event => {
        event.preventDefault();
        if (validate1()) {
            ApiCall(
                'PUT',
                baseURL + PROFILE_ENDPOINT,
                {
                    "accountDocument": userData.accountDocument,
                    "address": userData.address,
                    "bankDetails": userData.bankDetails,
                    "companyDetails": userData.companyDetails,
                    "drivingLicenseDetails": userData.drivingLicenseDetails,
                    "identityDetails": userData.identityDetails,
                    "profileRoles": userData.profileRoles,
                    "userdetails": {
                        "profilePicture": "string",
                        "user": {
                            "companyName": "string",
                            "countryCode": userData.userdetails?.user.countryCode,
                            "employeeId": userData.userdetails.id,
                            "firstName": firstname,
                            "lastName": lastname,
                            "userEmail": userData.userdetails?.user.userEmail,
                            "userMobile": userData.userdetails?.user.userMobile,
                        },
                        "userType": userData.userdetails?.userType,
                        "username": userData.userdetails?.username
                    }
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == 500) {
                        console.log('I am 500!');
                    }
                    else {
                        console.log('I am 200!');
                        console.log('I am 200!');
                        setFirstname(firstname);
                        setLastname(lastname);
                        setIsEdit(false); setIsSave(true);
                    }
                }
            });
        }
    }
    const validate1 = () => {
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        let isValid = true;
        if (!firstname) {
            isValid = false;
            firstnameerror = Message.validation.required;
            document.getElementById('firstname').style.border = "1px solid #841300";
        } else if (!patternCharacter.test(firstname)) {
            isValid = false;
            firstnameerror = Message.validation.alpha;
            document.getElementById('firstname').style.border = "1px solid #841300";
        } else {
            document.getElementById('firstname').style.border = "1px solid #B2B2B2";
        }
        if (!lastname) {
            isValid = false;
            lastnameerror = Message.validation.required;
            document.getElementById('lastname').style.border = "1px solid #841300";
        } else if (!patternCharacter.test(lastname)) {
            isValid = false;
            lastnameerror = Message.validation.alpha;
            document.getElementById('lastname').style.border = "1px solid #841300";
        } else {
            document.getElementById('lastname').style.border = "1px solid #B2B2B2";
        }
        setFirstnameError(firstnameerror);
        setLastnameError(lastnameerror);
        return isValid;
    }
    useEffect(() => {
        // api call
        if (getUserDetails) {
            setUserDetails(false);
            ApiCall(
                'GET',
                baseURL + PROFILE_ENDPOINT + `?userName=${userProfileDataR.userEmail}`,
                {},
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                false
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == 500) {
                        console.log('I am 500!');
                    }
                    else {
                        console.log('I am 200!');
                        setUserData(data);
                        console.log("profile data", data);
                    }
                }
                else {
                    console.log();
                }
            })
        }
    }, []);
    return (
        <div>
            <div class="hfullon">
                <MetaDecorator title={TitleDescription.viewProfilePageTitle} description={TitleDescription.viewProfilePageDescription} />
                <Header tilesFetched={() => { }} />
                <div id="box1">
                    <nav className="navbar " class="navbar">
                        <div className="navbarname">
                            <span id="navc">Hello User</span>
                        </div>
                        <div class="hnavsave ">
                            <img src={isEdit ? editenable : edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                            <a onClick={(EditValue)} id={isEdit ? "h1save" : "edit"} class=" pr-4" >Edit</a>
                            <img src={isEdit ? saveEnable : save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                            <small onClick={SaveValue} id={isEdit ? "h1saveEnable" : "h1save"} >Save</small>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <div class="hellomaincard">
                        {
                            //edit card for person details
                            isEdit ?
                                <div class="hellonavcard" >
                                    <div class="hellouserrow1">
                                        <div class="hellouserinput1">
                                            <small class="name">First Name</small>
                                            <br />
                                            <input class="inputText"
                                                id="firstname" value={firstname}
                                                onBlur={() =>
                                                    setFirstname(firstname?.trim())
                                                }
                                                onChange={handleChangeFirstName}
                                                type="text" />
                                            <div className="bankinfoerror12">{firstnameerror}</div>
                                        </div>
                                        <div class="hellouserinput1">
                                            <small class="name">Last Name</small>
                                            <br />
                                            <input class="inputText" id="lastname"
                                                onBlur={() =>
                                                    setLastname(lastname?.trim())
                                                }
                                                value={lastname} onChange={handleChangeLastName} />
                                            <div className="bankinfoerror12">{lastnameerror}</div>
                                        </div>
                                        <div class="hellouserinputEmail">
                                            <small class="name">Email Address</small>
                                            <br />
                                            <small class="mobile">{userData.userdetails?.user.userEmail}</small>
                                        </div>
                                    </div>
                                </div>
                                :
                                // static view of person details
                                <div class="hellonavcard" >
                                    <div class="hellouserrow1">
                                        <div class="hellouserinput1">
                                            <small class="name">First Name</small>
                                            <br />
                                            {!isSave ? <small class="name1">{userData.userdetails?.user.firstName}</small> : <small class="name1">{firstname}</small>}
                                        </div>
                                        <div class="hellouserinput1">
                                            <small class="name">Last Name</small>
                                            <br />
                                            {!isSave ? <small class="name1">{userData.userdetails?.user.lastName}</small> : <small class="name1">{lastname}</small>}
                                        </div>
                                        <div class="hellouserinputEmail">
                                            <small class="name">Email Address</small>
                                            <br />
                                            <small class="mobile">{userData.userdetails?.user.userEmail}</small>
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
                <div class="footer22">
                    <Footer2 />
                </div>
            </div>
            <div class="footer11">
                <Footer />
            </div>
        </div>
    );
}
export default ViewProfile;
